import { render, staticRenderFns } from "./ModalGestionnaire.vue?vue&type=template&id=10bf3c74&"
import script from "./ModalGestionnaire.vue?vue&type=script&lang=js&"
export * from "./ModalGestionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports